<div class="general-upsell">
  <div *ngIf="config.isUpsellSubmissionSuccessful">
    <div class="image-container">
      <img class="image desktop" [src]="config.imageUrlDesktop" />
      <img class="image mobile" [src]="config.imageUrlMobile" />
    </div>
    <div class="p-phx-web-space-extra-large text-center">
      <div *ngIf="!config.isUpsellSubmitted" class="d-flex flex-col justify-center align-items-center">
        <h2 class="phx-web-color-content-standard pb-phx-web-space-extra-extra-small">
          {{config.heading}}
        </h2>
        <p class="phx-web-color-content-subdued pb-phx-web-space-small-medium">
          {{config.description}}
        </p>
        <div class="cta-container">
          <button phx-button phxButtonRole="primary" class="cta" (click)="primaryCtaClick()">
            {{config.primaryCta.text}}
          </button>
          <button phx-button phxButtonRole="secondary" class="cta" (click)="secondaryCtaClick()">
            {{config.secondaryCta.text}}
          </button>
        </div>
      </div>
      <div *ngIf="config.isUpsellSubmitted" class="d-flex flex-col justify-center align-items-center">
        <h2 class="phx-web-color-content-standard">
          {{config.submissionSuccessfulContent.heading}}
        </h2>
        <p *ngFor="let description of config.submissionSuccessfulContent.descriptions" class="phx-web-color-content-subdued">
          {{description}}
        </p>
      </div>
    </div>

    <hr class="divider" />

    <footer class="p-phx-web-space-medium-large">
      <p class="text-center mb-phx-web-space-small-medium phx-web-color-content-subdued">
        {{config.footerDescription}}
      </p>
      <div class="account-manager-info">
        <div *ngIf="config.accountManager.name" class="d-flex justify-center align-items-center mb-phx-web-space-medium">
          <img class="mr-phx-web-space-small-medium border-radius-circle" [src]="config.accountManager.thumbnail" width="20" height="20" />
          <p class="phx-web-color-content-standard bold tracking-tighter">
            {{config.accountManager.name}}
          </p>
        </div>
        <div class="account-manager-phone-email">
          <a
            class="phone phx-web-color-content-subdued tracking-tighter d-flex justify-space-between align-items-center mr-phx-web-space-extra-large"
            href="tel:{{removeSpacesAndParenthesis(config.accountManager.phoneNumber)}}"
            (click)="phoneClick()"
          >
            <i phx-icon [phxIcon]="MOBILE_ICON" class="mr-phx-web-space-small-medium"></i>
            {{config.accountManager.phoneNumber}}
          </a>
          <a
            class="email phx-web-color-content-subdued tracking-tighter d-flex justify-space-between align-items-center"
            href="mailto:{{config.accountManager.email}}"
            (click)="emailClick()"
          >
            <i phx-icon [phxIcon]="EMAIL_ICON" class="mr-phx-web-space-small-medium"></i>
              {{config.accountManager.email}}
          </a>
        </div>
      </div>
    </footer>
  </div>

  <div *ngIf="config.isUpsellSubmitted && !config.isUpsellSubmissionSuccessful" class="error-state">
    <div class="d-flex flex-col justify-center align-items-center p-24">
      <i phx-icon [phxIcon]="ERROR_TRIANGLE_ICON" [size]="40" [color]="RED_60"></i>
      <h2 class="phx-web-color-content-subdued phx-web-type-title-medium m-0 mt-12">
        {{config.submissionFailureContent.heading}}
      </h2>
      <p *ngFor="let description of config.submissionFailureContent.descriptions" class="phx-web-color-content-subdued m-0 mt-8">
        {{description}}
      </p>
      <a phx-button phxButtonRole="primary" class="mr-phx-web-space-extra-small ml-phx-web-space-extra-small mt-24 rounded" (click)="refreshPageCallback()">
        {{config.submissionFailureContent.ctaText}}
      </a>
    </div>
  </div>
</div>
